function AppFooterCopyright() {
	return (
		<div className="pt-6 border-t border-black/[0.06] dark:border-white/[0.08] text-center text-xs text-slate-500 dark:text-slate-400">
			<div>
				&copy; {new Date().getFullYear()}{' '}
				<a
					href="https://ethanwei.me"
					className="font-medium text-slate-700 dark:text-slate-300 hover:text-sky-600 dark:hover:text-sky-400 transition-colors"
				>
					Ethan Wei
				</a>
				. All rights reserved. Built with React &amp; Tailwind CSS.
			</div>
		</div>
	);
}

export default AppFooterCopyright;
